export default __webpack_public_path__ + "static/6-control-panel-8910b1f9b6f8927543ba8633ff6ce351.jpg";